import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import { resetSearch } from '../store/reducers/searchReducer';
import { resetListQueryFilters } from '../store/reducers/listFilterReducer';
import { resetListPageAndSort } from '../store/reducers/listPageAndSortReducer';

type TabBarProps = {
	links?: { title: string; path: string; icon?: string }[];
};
const TabBar = ({ links }: TabBarProps) => {
	const dispatch = useDispatch();
	const [activeLink, setActiveLink] = useState('');
	const navigate = useNavigate();

	useEffect(() => {
		if (!links) return;
		const currentRoute = links.find((e) =>
			window.location.href.includes(e.path),
		);
		setActiveLink(currentRoute?.path || '');
	}, [links]);

	const handleClick = (route: string) => {
		dispatch(resetSearch(null));
		dispatch(resetListQueryFilters(null));
		dispatch(resetListPageAndSort(null));
		setActiveLink(route);
	};

	return (
		<div className="flex gap-x-5 py-3 px-4 bg-white rounded-lg">
			{links?.map((e, i) => {
				return (
					<NavLink
						key={i}
						to={e.path}
						onClick={() => handleClick(e.path)}
						className={`py-1 flex flex-col text-rcrm-text-gray font-semibold ${activeLink === e.path ? 'text-rcrm-primary-blue' : ''}`}
					>
						{e.icon ? (
							<div className="flex items-center gap-x-1">
								<img className="w-4 h-4" src={e.icon} alt="" />
								{e.title}
							</div>
						) : (
							e.title
						)}
						{activeLink === e.path ? (
							<div className="flex">
								<div className="w-3/4 h-1 bg-rcrm-primary-blue"></div>
								<div className="w-1/4 h-1 bg-rcrm-lime"></div>
							</div>
						) : null}
					</NavLink>
				);
			})}
		</div>
	);
};

export default TabBar;
